<script setup lang="ts">
import PaymentMethods from "@/views/playground/planner/business-management/service-management/PaymentMethods.vue";
</script>

<template>
  <payment-methods></payment-methods>
</template>

<style scoped></style>
